class $http {
    constructor() {
        this.init()
    }

    init() {
        this.tokenMap = new Map();
        this.$http = axios.create({
            baseURL: 'api'
        });
        this.interceptRequest()
        this.interceptResponse()
    }

    interceptRequest() {
        let self = this;
        this.$http.interceptors.request.use(function (config) {
            // 如果请求正在发生，则取消此次请求
            config.headers.get["Content-Type"] = "application/json;charset=UTF-8";
            config.headers.post["Content-Type"] = "application/json;charset=UTF-8";
            if (self.tokenMap.has(config.url)) {
                self.cancel('取消重复请求')
            } else {
                self.tokenMap.set(config.url, self.cancel)
            }
            return config;
        }, function (error) {
            // 对请求错误做些什么
            return Promise.reject(error);
        });
    }

    interceptResponse() {
        let self = this;
        this.$http.interceptors.response.use(function (response) {
            response.headers["Content-Type"] = "application/x-www-form-urlencoded";
            self.tokenMap.delete(response.config.url)//请求完成后,删除缓存中的url
            return response;
        }, function (error) {
            if (axios.isCancel(error)) {
                return Promise.reject(error);
            }
            // 对响应错误做点什么
            return Promise.reject(error);
        });
    }

    post(url) {
        return this.send({
            method: 'post',
            url: url
        })
    }

    get(url) {
        return this.send({
            method: 'get',
            url: url
        })
    }

    send(params) {
        let self = this;
        let token = new axios.CancelToken(function executor(c) {
            self.cancel = c;
        });
        return self.$http({
            url: params.url,
            method: params.method, // default
            params: params.params,//get参数
            data: params.data,
            cancelToken: token,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
    }
}

export default $http



// WEBPACK FOOTER //
// ./src/util/toolClass/http.js